import React from 'react';

function Indicators() {
  return (
      <div>Indicators</div>
  );
}

export default Indicators;